import React, { useCallback } from 'react';
import { Flex } from '@atlaskit/primitives';
import type { AsyncLoadOptions } from '@atlassian/jira-jql-builder-basic-picker/src/common/types.tsx';
import type { OrderByField, SelectedOrderByFields } from '../types.tsx';
import AddFieldPicker from './add-field-picker/index.tsx';
import OrderByFieldPicker from './order-by-field-picker/index.tsx';

type Props = {
	fields: SelectedOrderByFields;
	onLoadPickerOptions: AsyncLoadOptions;
	onChange: (newFields: SelectedOrderByFields) => void;
};

const BasicOrderBySelect = ({ fields, onLoadPickerOptions, onChange }: Props) => {
	const onChangeField = useCallback(
		(index: number, field: OrderByField) => {
			const nextFields = fields.map((currentField, currentIndex) =>
				index === currentIndex ? { ...field } : currentField,
			);

			onChange(nextFields);
		},
		[fields, onChange],
	);

	const onRemoveField = useCallback(
		(index: number) => {
			const nextFields = fields.filter((currentField, currentIndex) => index !== currentIndex);
			onChange(nextFields);
		},
		[fields, onChange],
	);

	const onAddnewField = useCallback(
		(field: OrderByField) => {
			const nextFields = [...fields, field];
			onChange(nextFields);
		},
		[fields, onChange],
	);

	return (
		<Flex gap="space.100" direction="column">
			{fields.map((field, fieldIndex) => (
				<OrderByFieldPicker
					key={fieldIndex}
					field={field}
					fieldIndex={fieldIndex}
					onChange={onChangeField}
					onLoadOptions={onLoadPickerOptions}
					onRemove={onRemoveField}
				/>
			))}
			<AddFieldPicker onLoadOptions={onLoadPickerOptions} onSelectField={onAddnewField} />
		</Flex>
	);
};

export default BasicOrderBySelect;
